export const en = {
    MB: 'MB',
    'action-text': 'Select a file',
    'button-title-copy': 'Copy the embed code',
    'button-title-delete': 'Delete',
    'button-title-download': 'Download',
    confirm: 'Are you sure you want to delete this file?',
    'drop-text': 'to upload',
    'error-delete-title': 'Couldn\'t delete file',
    'error-empty-description': 'There aren\'t any files on this page yet. ',
    'error-empty-title': 'There\'s nothing here',
    'error-get-description': 'Try again',
    'error-get-title': 'Couldn\'t load the files list',
    'error-message-limit': 'Try again later',
    'error-message-size-limit': 'File is too large',
    'error-message-validation': 'File name contains invalid characters',
    'error-upload-text': 'Couldn\'t load file',
    title: 'Files'
};
